"use strict";
checkList.classy.controller({
    name: 'TuitionAdjustmentController',
    inject: ['$scope', 'RestService', 
        'ResetService', 'ApplicationService', 'BinFactory', 'PutService', 'CalculationService', 'SchoolModelService'],
    init: function () {
        this.$.setAnswer(78);
        this.$.tuitions = Array();
        this.displaytuitions();
        this.$.isArchive = this.BinFactory.isArchive();
    },
    displaytuitions: function()
    {
        for (var i = 0; i < this.ApplicationService.getAwardData().applicants.length; i++) {
            this.$.tuitions[i] = this.ApplicationService.getAwardData().applicants[i].App_Tuition;
        }
    },
    tuitionAdjustmentComplete: function ()
    {
        var self = this;
        this.displaytuitions(); 

        this.PutService.putApplicant().then(function (results) {
            var caseNo = 'case78';
            var queue = [];
            self.CalculationService.reCalc();
            self.$.alertPut(queue, caseNo, 0);
        });
    },
    resetthis: function(alert)
    {
        /* istanbul ignore next */
        this.ResetService.resetWithPrompt('Tuition');
        this.displaytuitions(); 
        this.$.answer = {}; /* istanbul ignore next */
    }
});
